import axios from "axios";
import { API_URL } from "constants/constants";

let axiosGeneral = axios.create({
  baseURL: API_URL,
  timeout: 20000,
});

// Authorisation Header changes constantly
//axiosConfig.defaults.headers.common['Authorization'] = 'AUTH TOKEN FROM INSTANCE';

// add configure interceptors

export default axiosGeneral;
